// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dev-login-container {
  max-width: 420px;
  margin: 80px auto;
  padding: 32px;
  background: #ffffff;
  border-radius: 10px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  text-align: center;
}

.dev-login-title {
  font-size: 1.8rem;
  margin-bottom: 8px;
  color: #222;
}

.dev-login-subtitle {
  font-size: 0.95rem;
  color: #666;
  margin-bottom: 24px;
}

.dev-login-form {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.dev-login-label {
  display: flex;
  flex-direction: column;
  text-align: left;
  font-size: 0.85rem;
  color: #444;
  gap: 6px;
}

.dev-login-input {
  padding: 10px 12px;
  font-size: 0.95rem;
  border-radius: 6px;
  border: 1px solid #ccc;
  outline: none;
  transition: border-color 0.15s, box-shadow 0.15s;
}

.dev-login-input:focus {
  border-color: #f36e21; /* RIT orange accent */
  box-shadow: 0 0 0 2px rgba(243, 110, 33, 0.2);
}

.dev-login-submit {
  margin-top: 12px;
  padding: 12px;
  font-size: 1rem;
  border-radius: 8px;
  border: none;
  background-color: #f36e21;
  color: #ffffff;
  cursor: pointer;
  transition: background-color 0.15s, transform 0.05s;
}

.dev-login-submit:hover {
  background-color: #dd5f1b;
}

.dev-login-submit:active {
  transform: translateY(1px);
}

.dev-login-submit:disabled {
  background-color: #f3a679;
  cursor: not-allowed;
}

.dev-login-error {
  margin-bottom: 16px;
  color: #b00020;
  font-size: 0.9rem;
}`, "",{"version":3,"sources":["webpack://./src/styles/devLogin.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,0CAA0C;EAC1C,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,sBAAsB;EACtB,aAAa;EACb,gDAAgD;AAClD;;AAEA;EACE,qBAAqB,EAAE,sBAAsB;EAC7C,6CAA6C;AAC/C;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,eAAe;EACf,kBAAkB;EAClB,YAAY;EACZ,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,mDAAmD;AACrD;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,iBAAiB;AACnB","sourcesContent":[".dev-login-container {\n  max-width: 420px;\n  margin: 80px auto;\n  padding: 32px;\n  background: #ffffff;\n  border-radius: 10px;\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);\n  text-align: center;\n}\n\n.dev-login-title {\n  font-size: 1.8rem;\n  margin-bottom: 8px;\n  color: #222;\n}\n\n.dev-login-subtitle {\n  font-size: 0.95rem;\n  color: #666;\n  margin-bottom: 24px;\n}\n\n.dev-login-form {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.dev-login-label {\n  display: flex;\n  flex-direction: column;\n  text-align: left;\n  font-size: 0.85rem;\n  color: #444;\n  gap: 6px;\n}\n\n.dev-login-input {\n  padding: 10px 12px;\n  font-size: 0.95rem;\n  border-radius: 6px;\n  border: 1px solid #ccc;\n  outline: none;\n  transition: border-color 0.15s, box-shadow 0.15s;\n}\n\n.dev-login-input:focus {\n  border-color: #f36e21; /* RIT orange accent */\n  box-shadow: 0 0 0 2px rgba(243, 110, 33, 0.2);\n}\n\n.dev-login-submit {\n  margin-top: 12px;\n  padding: 12px;\n  font-size: 1rem;\n  border-radius: 8px;\n  border: none;\n  background-color: #f36e21;\n  color: #ffffff;\n  cursor: pointer;\n  transition: background-color 0.15s, transform 0.05s;\n}\n\n.dev-login-submit:hover {\n  background-color: #dd5f1b;\n}\n\n.dev-login-submit:active {\n  transform: translateY(1px);\n}\n\n.dev-login-submit:disabled {\n  background-color: #f3a679;\n  cursor: not-allowed;\n}\n\n.dev-login-error {\n  margin-bottom: 16px;\n  color: #b00020;\n  font-size: 0.9rem;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
